import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="bg-card rounded-xl border border-border shadow-warm p-4 md:p-6">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => {
          const isActive = step?.id === currentStep;
          const isCompleted = step?.id < currentStep;
          const isClickable = step?.id < currentStep;

          return (
            <React.Fragment key={step?.id}>
              {/* Step Circle */}
              <button
                onClick={() => isClickable && onStepClick?.(step?.id)}
                disabled={!isClickable}
                className={`
                  flex flex-col items-center gap-2 transition-all duration-250
                  ${isClickable ? 'cursor-pointer hover:scale-105' : 'cursor-default'}
                `}
              >
                <div
                  className={`
                    w-12 h-12 rounded-full flex items-center justify-center transition-all duration-250
                    ${isActive ? 'bg-primary text-primary-foreground shadow-lg scale-110' : ''}
                    ${isCompleted ? 'bg-success text-success-foreground' : ''}
                    ${!isActive && !isCompleted ? 'bg-muted text-muted-foreground' : ''}
                  `}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={20} />
                  ) : (
                    <Icon name={step?.icon} size={20} />
                  )}
                </div>
                <div className="text-center hidden md:block">
                  <p
                    className={`
                      text-xs font-medium transition-colors
                      ${isActive ? 'text-primary' : ''}
                      ${isCompleted ? 'text-success' : ''}
                      ${!isActive && !isCompleted ? 'text-muted-foreground' : ''}
                    `}
                  >
                    {step?.title}
                  </p>
                  <p className="text-xs text-muted-foreground mt-0.5">
                    {step?.description}
                  </p>
                </div>
              </button>
              {/* Connector Line */}
              {index < steps?.length - 1 && (
                <div
                  className={`
                    flex-1 h-0.5 mx-2 transition-all duration-250
                    ${step?.id < currentStep ? 'bg-success' : 'bg-muted'}
                  `}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
      {/* Mobile Step Title */}
      <div className="md:hidden mt-4 text-center">
        <p className="text-sm font-medium text-foreground">
          {steps?.[currentStep - 1]?.title}
        </p>
        <p className="text-xs text-muted-foreground">
          {steps?.[currentStep - 1]?.description}
        </p>
      </div>
    </div>
  );
};

export default ProgressIndicator;